import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { DynamicFieldType } from "../dynamicField/types";

export enum FilterType {
  SELECT = "select",
  TEXT = "text",
  DATE = "date",
  TIMESTAMP = "timestamp",
  MULTI_SELECT = "multi_select",
  MULTI_SELECT_FREE_SOLO = "multi_select_free_solo",
  FETCH_SELECT = "fetch_select",
  FETCH_MULTI_SELECT = "fetch_multi_select",
  ATTEMPTS = "attempts",
}

export enum FilterOperator {
  EQUALS = 'eq',
  NOT_EQUALS = 'neq',
  GREATER_THAN = 'gt',
  GREATER_THAN_OR_EQUALS = 'gte',
  LESS_THAN = 'lt',
  LESS_THAN_OR_EQUALS = 'lte',
  LIKE = 'like',
  NOT_LIKE = 'not like',
  IN = 'in',
  NOT_IN = 'not in',
  AND = 'and',
  OR = 'or',
  IS_NULL = 'null',
  IS_NOT_NULL = 'not null',
  ANY = 'any',
  NOT_ANY = 'not any',
}

export interface Option {
  label: string;
  value: string;
  indicator?: boolean;
}

export interface FilterCondition {
  operator: FilterOperator;
  field?: string;
  value: string | string[] | FilterCondition[] | Option[] | Option;
}

export interface FilterGroup {
  conditions: FilterCondition[];
}
export interface FilterOption {
  name: string;
  label: string;
  value?: string | Option[] | Option | { from?: string; to?: string };
  type: FilterType;
  options?: Option[];
  getOptionsUrl?: string;
  fetchLabel?: string;
  fetchValue?: string;
  placeholder?: string;
  withoutFetchPagination?: boolean;
}

export interface FilterDrawerOption {
  name: string;
  label: string;
  value: string | Option[] | Option;
  type: DynamicFieldType;
  options?: {
    options?: Option[];
    min?: number;
    max?: number;
    step?: number;
  };
}

export interface Filters {
  [key: string]: FilterOption;
}

export interface FiltersDrawer {
  [key: string]: FilterDrawerOption;
}

export interface TableHeadCell {
  id: string;
  label: string;
  width?: number;
  align: string;
  sortBy?: string;
  sx?: SxProps<Theme>;
}

export interface Column {
  header: TableHeadCell;
  accessorKey: string;
  hideColumn?: boolean;
  getCellValue?: (row: any) => any;
  cell?: {
    sx?: SxProps<Theme>;
  };
}

export interface ExpandableRowConfig {
  enabled: boolean;
  renderExpandedContent: (row: any) => React.ReactNode;
  expandIcon?: React.ReactNode;
  collapseIcon?: React.ReactNode;
}

export interface ExpandedRows {
  expanded: number[];
  hidden: number[];
}

export interface CallBack {
  disposition: string;
  time: number;
  tries: number;
}


export type SortDir = "asc" | "desc";
